import { BoardCard, BoardList } from '../../dashboard/BoardLook'
import type { MapLink } from './mapApi'

/*
 * Legaturile dintre aplicatii pe harta: un rand pe cardul fiecarei aplicatii
 * ("Depends on Charisma ERP · Needed by Opera PMS") si un card de tablou cu
 * toate, cu ce trece intre ele. Tot fara linii desenate - vezi de ce in capul
 * lui `ApplicationMapPage`.
 */

export function AppLinkLine({ appId, links }: { appId: number; links: MapLink[] }) {
  const needs = links.filter((l) => l.fromId === appId).map((l) => l.to)
  const neededBy = links.filter((l) => l.toId === appId).map((l) => l.from)
  if (needs.length === 0 && neededBy.length === 0) return null

  return (
    <div className="am-support am-links" data-app={appId}>
      {needs.length > 0 && (
        <>
          <span className="am-label">Depends on</span> <strong>{needs.join(', ')}</strong>
        </>
      )}
      {needs.length > 0 && neededBy.length > 0 && <span className="am-muted"> · </span>}
      {neededBy.length > 0 && (
        <>
          <span className="am-label">Needed by</span> <strong>{neededBy.join(', ')}</strong>
        </>
      )}
    </div>
  )
}

/**
 * Cardul "Links between applications": un rand pe legatura, "A -> B", cu ce
 * trece intre ele dedesubt. Numele duc la cardul aplicatiei (`#app-N`). Fara
 * legaturi, cardul lipseste - nu un card gol.
 */
export function AppLinksCard({ links }: { links: MapLink[] }) {
  if (links.length === 0) return null
  const apps = new Set(links.flatMap((l) => [l.fromId, l.toId])).size

  return (
    <BoardCard module="overview" icon="fa-project-diagram" value={links.length} kicker={`Between ${apps} applications`} title="Links between applications" wide tall={links.length > 2}>
      <BoardList>
        <div className="odb-note am-links-lead">When the application on the right stops, the one on the left is affected too.</div>
        <ul className="am-linklist" id="amLinks">
          {links.map((l) => (
            <li key={l.id} data-link={l.id}>
              <div className="odb-row">
                <span className={`odb-dot odb-c-${l.inCmdb ? 'ok' : 'flat'}`} aria-hidden="true" />
                <span className="odb-row-label">
                  <a href={`#app-${l.fromId}`}>{l.from}</a> <i className="fas fa-long-arrow-alt-right am-muted" aria-hidden="true"></i>{' '}
                  <a href={`#app-${l.toId}`}>{l.to}</a>
                </span>
              </div>
              <div className="odb-fold">
                <div className="odb-note">{l.description !== '' ? l.description : '-'}</div>
              </div>
            </li>
          ))}
        </ul>
      </BoardList>
    </BoardCard>
  )
}
